<template>
  <Modal
          v-model="_value"
          width="550"
          title="分配SIM卡"
          @on-visible-change="visibleChange"
          ok-text="修改"
          cancel-text=""
          @on-ok="onOk">
    <div>

      <Form ref="loginForm" :model="simInfoIds">
          <FormItem prop="registrationNum" label="分配数量：">
            {{simInfoIds.length}}
          </FormItem>
        <FormItem prop="name" label="安装员">
          <Select class="field" v-model="simInfo.installerId">
            <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
          </Select>
        </FormItem>
      </Form>

    </div>
  </Modal>
</template>
<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  // import AddPositioningDeviceInfoModal from '@/views/im/components/add-positioning-device-info-modal'
  import PositioningDeviceInfoDetailModal from '@/views/im/components/positioning-device-info-detail-modal'


  import {
    Cell,
    CellGroup,
    Field,
    Row,
    Col,
    Button,
    Dialog,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Picker,
    Popup,
    Divider,
    Collapse,
    CollapseItem,
    DatetimePicker,
    Tag,
    DropdownMenu,
    DropdownItem,
    Sticky,
    Icon,
    Search,
    PullRefresh,
    List,
    Loading,
    Toast,
  } from 'vant'


  Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
          .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
          .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);
  export default {
    name: 'siminfochangeinstallermodal',
    components: {
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      listValue: null,
    },
    data () {
      return {
        installers: [],
        simInfo: {
          id: null,
          installerId: null,
        },

        simInfoList: [],
        simInfoIds:[],
      }
    },
    methods: {
      ...mapActions([
      ]),
      onOk(){
        store.dispatch('SimInfoServ_BatchChangeInstaller', {
          params:
                  {
                    ids:this.simInfoIds,
                    installerId:this.simInfo.installerId,
                  },
          urlparams: null
        }).then(() => {
          this.$Message.success('绑定安装员成功')
          this.$emit('on-success');
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail');
        })
      },
      visibleChange (val) {
        if (val) {
          console.log(this._listValue)
          this.simInfoIds = this._listValue

          store.dispatch('UserServ_GetAllUsers', {
            params: {},
            urlparams: {roleIds: [8, 14]}
          }).then(() => {
            this.installers = store.getters.get_User_GetAllUsersResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get () {
          return this.initValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _listValue: {
        get() {
          return this.listValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        },
      },
    },
    mounted () {
      this.$nextTick(() => {
      })
    }
  }
</script>
